import React__default, { useState, Children, Fragment } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import { BaseButton } from '../../navigation/LegacyButton/BaseButton.es.js';
import { Icon } from '../Icon/Icon.es.js';
import { Indicator } from '../../navigation/Indicator/Indicator.es.js';
import { Paginator } from '../../navigation/Paginator/Paginator.es.js';
import { ScrollSnap } from './ScrollSnap/ScrollSnap.es.js';
import { uniqueId } from '../../../utils/uniqueId.es.js';

const carouselWrapper = "_carousel-wrapper_1mflc_1";
const carousel = "_carousel_1mflc_1";
const paginator = "_paginator_1mflc_38";
const arrowButton = "_arrow-button_1mflc_47";
const scrollSnapChild = "_scroll-snap-child_1mflc_79";
const styles = {
	carouselWrapper: carouselWrapper,
	carousel: carousel,
	paginator: paginator,
	arrowButton: arrowButton,
	scrollSnapChild: scrollSnapChild
};

const ArrowButton = (props) => {
  const icon = {
    prev: "arrowSmallLeft",
    next: "arrowSmallRight"
  }[props.direction];
  return React__default.createElement(
    "span",
    { className: styles.arrowButton, "data-disabled": props.isDisabled ? true : void 0, "data-direction": props.direction, "data-zds": true },
    React__default.createElement(
      BaseButton,
      { "aria-label": `${props.direction} image`, color: props.color, disabled: props.isDisabled, isPill: true, isSquare: true, onClick: props.onClick, size: "large" },
      React__default.createElement(Icon, { isBlock: true, name: icon, size: 30 })
    )
  );
};
const Carousel = ({ children, slideWidth, arrowOffset = "50%", edgeColor = void 0, fadeInactive = void 0, gap: _deprecatedGapProp = 20, id = void 0, onActiveSlideChange = void 0, paginatorStyle = void 0, showArrows = void 0, showPaginator = false, arrowButtonColor = "primary" }) => {
  const gap = 20;
  const [pageIndex, setPageIndex] = useState(0);
  const isFirstPage = pageIndex === 0;
  const isLastPage = pageIndex === Children.count(children) - 1;
  const changePageIndex = (nextIndex, source) => {
    setPageIndex(nextIndex);
    if (onActiveSlideChange && pageIndex !== nextIndex) {
      onActiveSlideChange(nextIndex, pageIndex, { source });
    }
  };
  const paginatorAriaLabel = id ? `${id} carousel paginator` : uniqueId("carousel paginator ");
  let paginator = paginatorStyle && {
    paginator: React__default.createElement(Paginator, { "aria-label": paginatorAriaLabel, currentPageIndex: pageIndex, onPaginate: ({ pageIndex: index }) => changePageIndex(index, "paginator"), pageUrls: Array.from({ length: Children.count(children) }) }),
    indicator: React__default.createElement(Indicator, { "aria-label": "List of images", color: "gray", count: Children.count(children), noun: "image", onChangeIndex: (index) => changePageIndex(index, "indicator"), selectedIndex: pageIndex })
  }[paginatorStyle];
  if (showPaginator || paginatorStyle) {
    paginator = React__default.createElement(Paginator, { "aria-label": paginatorAriaLabel, currentPageIndex: pageIndex, onPaginate: ({ pageIndex: index }) => changePageIndex(index, "paginator"), pageUrls: Array.from({ length: Children.count(children) }) });
  }
  return React__default.createElement(
    "div",
    { id, "data-zds": true, className: styles.carouselWrapper },
    React__default.createElement(
      "div",
      { className: styles.carousel, "data-fade-edges": edgeColor || showArrows, "data-first-page": isFirstPage ? true : void 0, "data-last-page": isLastPage ? true : void 0, style: {
        "--_zds-carousel-edge-color": edgeColor !== null && edgeColor !== void 0 ? edgeColor : Colors.PrimeWhite
      }, "data-zds": true },
      showArrows && React__default.createElement(
        Fragment,
        null,
        React__default.createElement(ArrowButton, { direction: "prev", isDisabled: isFirstPage, yOffset: arrowOffset, color: arrowButtonColor, onClick: () => {
          changePageIndex(pageIndex - 1, "previous");
        } }),
        React__default.createElement(ArrowButton, { direction: "next", isDisabled: isLastPage, yOffset: arrowOffset, color: arrowButtonColor, onClick: () => {
          changePageIndex(pageIndex + 1, "next");
        } })
      ),
      React__default.createElement(ScrollSnap, { gap, itemWidth: slideWidth, onScroll: (index) => {
        changePageIndex(index, "scroll");
      }, pageIndex, scrollSnapAlign: "center" }, React__default.Children.map(children, (child, i) => React__default.createElement("div", { className: styles.scrollSnapChild, key: i, "data-faded": fadeInactive && pageIndex !== i, "data-zds": true }, child)))
    ),
    paginator && React__default.createElement("div", { className: styles.paginator, "data-zds": true }, paginator)
  );
};

export { Carousel };
//# sourceMappingURL=Carousel.es.js.map
